<template>
  <q-card v-if="show" style="margin-top:20px;" square>
    <div class="result-title">
      <div class="title-text">Calculate Result</div>
      <i class="fas fa-times" style="margin-left:15px" @click="destroy">
        <q-tooltip>Close</q-tooltip>
      </i>
    </div>
    <div class="result-body">
      <div class="result">
        <span class="title">Calculated Diminished Value</span>
        <span class="val">{{ result }}</span>
      </div>
    </div>
  </q-card>
</template>

<script>
export default {
  name: "DimishedCalculateResult",
  computed: {
    result:{
      set(val) {
        this.$store.commit('dimishedValue/SET_RESULT', val)
      },
      get() {
        return this.$store.state.dimishedValue.result
      }
    },
    show: {
      set(val) {
        this.$store.commit('dimishedValue/SET_SHOW', val)
      },
      get() {
        return this.$store.state.dimishedValue.show
      }
    }
  },
  methods: {
    destroy() {
      this.show = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.result-title {
  display: flex;
  flex-flow: row nowrap;
  background-color: rgb(2, 123, 227);
  color: #fff;
  align-items: center;
  padding: 15px;

  .title-text {
    font-weight: 700;
    font-size: 20px;
    flex: 1;
  }

  i {
    cursor: pointer;
  }
}

.result-body {
  .result {
    padding: 15px;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
    font-weight: 700;

    .title {
      flex: 1;
    }

    .val {
      margin-left: 5px;
      padding: 5px;
      color: #fff;
      border-radius: 5px;
      background: crimson;
    }
  }
}
</style>